import type { SelectDropdownOption } from '../../../library/editors/elements/select-dropdown-option';
import { t } from 'src/i18n';

export const sectorOptions: SelectDropdownOption[] = [
  { value: 'HEALTH', text: t('features.sectorOptions.health.text') },
  { value: 'CRAFTS_TRANSPORTATION_CLEANING', text: t('features.sectorOptions.craftsTransportationCleaning.text') },
  { value: 'FOOD_ACCOMMODATION', text: t('features.sectorOptions.foodAccommodation.text') },
  { value: 'PERSONAL_TRADE_SERVICE', text: t('features.sectorOptions.personalTradeService.text') },
  { value: 'OFFICE', text: t('features.sectorOptions.office.text') },
  { value: 'OTHER', text: t('features.sectorOptions.other.text') },
];
